import { render, staticRenderFns } from "./technologyPolicy.vue?vue&type=template&id=52b7ae75&"
import script from "./technologyPolicy.vue?vue&type=script&lang=js&"
export * from "./technologyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./technologyPolicy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports